import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { documentTypesApi } from '@/api/documentTypes';
import { BulkImportDocuments } from './BulkImportDocuments';
import { Loader2 } from 'lucide-react';
export function BulkImportDocumentsWrapper({ onComplete }) {
    const [docTypes, setDocTypes] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        documentTypesApi.getAll().then(setDocTypes).catch(console.error).finally(() => setLoading(false));
    }, []);
    if (loading) {
        return _jsx("div", { className: "flex justify-center py-8", children: _jsx(Loader2, { className: "w-6 h-6 animate-spin" }) });
    }
    return (_jsx(BulkImportDocuments, { documentTypes: docTypes, onComplete: onComplete }));
}
//# sourceMappingURL=BulkImportDocumentsWrapper.js.map